import { IWorkflowFormServiceMock } from './workflow-form.mock.types';

export const mockWorkflowFormService = (): IWorkflowFormServiceMock => ({
  //submissions
  fetchWorkflowFormSubmissions: jest.fn(),
  fetchWorkflowFormSubmission: jest.fn(),
  updateWorkflowFormSubmissionState: jest.fn(),
  createWorkflowFormSubmission: jest.fn(),
  updateWorkflowFormSubmission: jest.fn(),
  deleteWorkflowFormSubmission: jest.fn(),

  fetchWorkflowFormSubmissionValidStateTransitions: jest.fn(),
  fetchWorkflowFormSubmissionsAvailableAssignees: jest.fn(),

  // activities
  fetchWorkflowFormSubmissionActivities: jest.fn(),

  fetchWorkflowFormSubmissionChecklists: jest.fn(),
  updateWorkflowFormSubmissionChecklist: jest.fn(),
  markCompleteWorkflowFormSubmissionChecklist: jest.fn(),
  fetchChecklistAssigneeOptions: jest.fn(),
  updateWorkflowFormSubmissionChecklistAssignee: jest.fn(),

  fetchWorkflowFormSubmissionDepartments: jest.fn(),

  // comments
  fetchWorkflowFormSubmissionComments: jest.fn(),
  fetchWorkflowFormSubmissionComment: jest.fn(),
  createWorkflowFormSubmissionComment: jest.fn(),
  updateWorkflowFormSubmissionComment: jest.fn(),
  deleteWorkflowFormSubmissionComment: jest.fn(),

  addWorkflowFormSubmissionCommentAttachments: jest.fn(),
  removeWorkflowFormSubmissionCommentAttachment: jest.fn(),

  // mentions
  fetchWorkflowFormSubmissionCommentsMentionableUsers: jest.fn(),
  exportWorkflowFormSubmissionPDF: jest.fn(),
  exportWorkflowFormSubmissionXLSX: jest.fn()
});
